<template>
	<div style="margin-left: 10px;">
			<div class="risk-control-warning">
				<div>
					<svg
						width="16"
						height="16"
						t="1632638414360"
						class="icon"
						viewBox="0 0 1024 1024"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						p-id="2150">
						<path
							d="M512 26.54814777C245.0014811 26.54814777 26.54814777 245.0014811 26.54814777 512s218.45333333 485.45185223 485.45185223 485.45185223 485.45185223-218.45333333 485.45185223-485.45185223S778.9985189 26.54814777 512 26.54814777z m194.18074112 533.9970378H317.81925888c-29.12711111 0-48.54518557-19.41807445-48.54518443-48.54518557s19.41807445-48.54518557 48.54518443-48.54518557h388.36148224c29.12711111 0 48.54518557 19.41807445 48.54518443 48.54518557s-19.41807445 48.54518557-48.54518443 48.54518557z"
							p-id="2151"
							fill="#FF4D4F"/>
					</svg>
				</div>
				<span>正在使用“{{platformName}}”身份验证服务
					<a v-if="platformUrl" :href="platformUrl" target="_blank">{{platformUrlName}}</a>
				</span>
			</div>

			<el-input :model-value="phoneNumber" style="width: 300px; margin-bottom: 20px;" disabled />

			<div class="phone-verify-code-container">
				<el-input
					v-model="phoneVerifyCode"
					type="text"
					placeholder="请输入验证码"
					:maxlength="inputMaxlength"
					id="phone-verify-code"
					@input="onInput"
				/>

				<div id="acquire-container">
					<TimeCount :before-count="sendSmsVerifyCode" />
				</div>
			</div>
			<div
				class="warning"
				:style="{ opacity: (isWarningShown ? 1 : 0) }">
				<svg width="14" height="14" t="1632638414360" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="2150">
					<path
						d="M512 26.54814777C245.0014811 26.54814777 26.54814777 245.0014811 26.54814777 512s218.45333333 485.45185223 485.45185223 485.45185223 485.45185223-218.45333333 485.45185223-485.45185223S778.9985189 26.54814777 512 26.54814777z m194.18074112 533.9970378H317.81925888c-29.12711111 0-48.54518557-19.41807445-48.54518443-48.54518557s19.41807445-48.54518557 48.54518443-48.54518557h388.36148224c29.12711111 0 48.54518557 19.41807445 48.54518443 48.54518557s-19.41807445 48.54518557-48.54518443 48.54518557z"
						p-id="2151" fill="#FF4D4F"></path>
				</svg>
<!--				<span>验证码错误！请重新输入</span>-->
				<span>{{dialogErrorMsg}}</span>
			</div>
		</div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import * as easy from "@/components/easy";
import TimeCount from "../TimeCount.vue"


const props = withDefaults(defineProps<{
	phoneNumber: string,
	platformName: string,
	platformUrlName: string,
	platformUrl: string,
	inputMaxlength?: number;

	sendSmsApi: () => Promise<void>;
	verifyAuthCodeApi: (code: string) => Promise<void>;

	popupCtx?: easy.PopupCtx<null>;
}>(), {
	inputMaxlength: 6
});

const phoneVerifyCode = ref('')
const isWarningShown = ref(false);
const dialogErrorMsg = ref('验证码错误！请重新输入')
const onInput = () => {
	isWarningShown.value = false;
	phoneVerifyCode.value = phoneVerifyCode.value.replace(/\D/g, '')
	
	if (phoneVerifyCode.value.length > 6) {
		phoneVerifyCode.value = phoneVerifyCode.value.slice(0, 6)
	} else {
		phoneVerifyCode.value = phoneVerifyCode.value.replace(/[^a-zA-Z0-9]/g, '')
	}
}

const sendSmsVerifyCode = async () => {
  try {
    await props.sendSmsApi();
  }
  catch(e) {
    switch (e.code) {
      case 100056:
        dialogErrorMsg.value = '长时间未操作，请关闭验证框重新登录';
        isWarningShown.value = true;
        break
      default:
        throw e;
    }
  }
}

const popup = easy.usePopup(props);
popup.resultDef(async () => {
	if(!phoneVerifyCode.value) {
		return;
	}

	try {
		await props.verifyAuthCodeApi(phoneVerifyCode.value);
		popup.done(null);
	}
	catch(e) {
    switch (e.code) {
      case 100056:
        dialogErrorMsg.value = '长时间未操作，请关闭验证框重新登录';
        isWarningShown.value = true;
        break
      case 100047:
        dialogErrorMsg.value = '未发送验证码，请先发送验证码';
        isWarningShown.value = true;
        break
      case 100013:
        dialogErrorMsg.value = '验证码错误！请重新输入';
        isWarningShown.value = true;
        break
      case 300001:
        dialogErrorMsg.value = '验证码错误！请重新输入';
        isWarningShown.value = true;
        break
      case 300002:
        dialogErrorMsg.value = '验证码错误！请重新输入';
        isWarningShown.value = true;
        break
      default:
        throw e;
    }
	}
})
</script>

<style lang="scss" scoped>
input[type="text"],
input[type="password"] {
  width: 300px;
  height: 40px;
  padding: 13px 16px;
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  outline: 0;
}

.risk-control-warning {
	display: flex;
	align-items: center;
	color: #ff4d4f;
	margin-bottom: 20px;

	span {
		font-size: 14px;
		margin-left: 8px;
	}
}

#phone {
	background: #f7f7f7;
	border: 1px solid #eeeeee;
	border-radius: 4px;
	margin-bottom: 20px;
}

.phone-verify-code-container {
	position: relative;
	width: 300px;

	#acquire-container {
		position: absolute;
		right: 10px;
		top: -4px;
		line-height: 40px;
		font-size: 14px;
		cursor: pointer;

		#acquire {
			color: #0C70F8;
		}

		#count-down {
			color: #dddddd;
		}
	}
}

.warning {
	height: 20px;
	color: #ff4d4f;
	line-height: 20px;
	font-size: 14px;
	display: flex;
	align-items: center;
	margin-bottom: 20px;

	span {
		display: inline-block;
		margin-left: 9px;
	}
}
</style>
